import { createFileRoute } from '@tanstack/react-router';

import { DevLoginScreen } from '../features/auth/dev-login-screen.js';
import { devOnlyGuard } from './-dev-only.js';

export const Route = createFileRoute('/dev/login')({
  beforeLoad: devOnlyGuard,
  component: DevLoginScreen,
});
